<template>
  <q-form ref="form" class="full-width q-px-md">
    <div class="row">
      <div class="col-12 q-pa-xs">
        <q-input
          v-model="formData.name"
          label="Points Table Name"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-12 q-pa-xs">
        <q-checkbox
          :true-value="1"
          :false-value="0"
          indeterminate-value="no-value"
          label="Apply points to finals only"
          v-model="formData.pointsForFinalsOnly"
        >
        </q-checkbox>
      </div>
      <div class="col-12 col-sm-6 q-pa-xs">
        <q-btn
          class="full-width"
          color="primary"
          no-caps
          @click="addAnotherPlacing"
        >
          Add another placing option
        </q-btn>
      </div>
      <div class="col-12 col-sm-6 q-pa-xs">
        <q-btn
          class="full-width"
          color="negative"
          no-caps
          @click="pointsTableDistribution.pop()"
        >
          Remove last placing option
        </q-btn>
      </div>
      <q-separator></q-separator>
      <div class="col-12">
        <q-scroll-area style="height: 300px">
          <div class="row">
            <div
              class="col-12"
              v-for="(placing, index) in pointsTableDistribution"
              :key="`pointsIndex_${index}`"
            >
              <div class="row q-py-sm">
                <div class="col q-px-xs">
                  <q-input
                    label="Placing"
                    v-model="placing.name"
                    readonly
                    v-bind="siteCFG.fields.general"
                  >
                  </q-input>
                </div>
                <div class="col q-px-xs">
                  <q-input
                    label="Points"
                    v-model="placing.value"
                    type="number"
                    v-bind="siteCFG.fields.general"
                  >
                  </q-input>
                </div>
              </div>
            </div>
          </div>
        </q-scroll-area>
      </div>
    </div>
  </q-form>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    components: {},
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        siteCFG: "settings/siteCFG",
        data: "pointsTable/current",
        dataLoading: "pointsTable/currentLoading",
      }),
    },
    props: {
      id: {
        default: null,
      },
    },
    watch: {
      id: function () {
        this.init();
      },
      data: function () {
        this.init();
      },
    },
    data: () => ({
      // Extra Data
      formData: {
        pointsForFinalsOnly: 0,
      },
      pointsTableDistribution: [
        {
          name: "1st",
          value: 0,
        },
      ],
      tab: "general",
    }),
    beforeCreate() {},
    mounted() {
      this.init();
      this.$store.dispatch("pointsTable/loadByID", this.id);
    },
    methods: {
      init() {
        if (this.data != null && this.data.id == this.id) {
          this.formData = JSON.parse(JSON.stringify(this.data));
          this.pointsTableDistribution = JSON.parse(this.formData.JSON);
        } else {
          this.formData = {
            pointsForFinalsOnly: 0,
          };
        }
      },
      create() {
        this.$emit("loadingStateChanged", true);
        this.formData.JSON = JSON.stringify(this.pointsTableDistribution);
        this.$store.dispatch("pointsTable/new", this.formData).then((result) => {
          this.$emit("loadingStateChanged", false);
          if (result.Result == "Success") {
            this.$emit("close", true);
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        });
      },
      save() {
        this.$emit("loadingStateChanged", true);
        this.formData.JSON = JSON.stringify(this.pointsTableDistribution);
        this.$store.dispatch("pointsTable/save", this.formData).then((result) => {
          this.$emit("loadingStateChanged", false);
          if (result.Result == "Success") {
            this.address = "";
            this.$emit("close", true);
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        });
      },
      addAnotherPlacing() {
        let number = this.pointsTableDistribution.length + 1;
        this.pointsTableDistribution.push({
          name: `${this.ordinal_suffix_of(number)}`,
          value: 0,
        });
      },
      ordinal_suffix_of(i) {
        var j = i % 10,
          k = i % 100;
        if (j == 1 && k != 11) {
          return i + "st";
        }
        if (j == 2 && k != 12) {
          return i + "nd";
        }
        if (j == 3 && k != 13) {
          return i + "rd";
        }
        return i + "th";
      },
    },
  };
</script>

<style lang="scss" scoped>
  .formSubTitle {
    font-weight: bold;
  }
</style>
